import { render, staticRenderFns } from "./CancelBookingConfirm.vue?vue&type=template&id=6b1a50d7&scoped=true&"
import script from "./CancelBookingConfirm.vue?vue&type=script&lang=js&"
export * from "./CancelBookingConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CancelBookingConfirm.vue?vue&type=style&index=0&id=6b1a50d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a50d7",
  null
  
)

export default component.exports